import { render, staticRenderFns } from "./StudyNewPageQuestions.vue?vue&type=template&id=af7ec20a&scoped=true"
import script from "./StudyNewPageQuestions.vue?vue&type=script&lang=js"
export * from "./StudyNewPageQuestions.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageQuestions.vue?vue&type=style&index=0&id=af7ec20a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ec20a",
  null
  
)

export default component.exports